<template>
  <label @click="onClick" class="yt_radio-label"
    :class="{'yt_radio-label--disabled': disabled }">
    <span class="yt_radio" tabindex="0"
      :class="{
        'yt_radio--active': isActive,
        'yt_radio--disabled': disabled,
        'yt_radio--checkbox': asCheckbox,
      }">
    </span>
    <slot></slot>
  </label>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Number],
      required: undefined,
    },
    selected: {
      type: [String, Number],
      default: undefined,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    asCheckbox: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: "selected",
    event: "click",
  },
  computed: {
    isActive() {
      return this.selected == this.value;
    },
  },
  methods: {
    onClick() {
      if (this.disabled) {
        return;
      }
      this.$emit('click', this.value);
    },
  }
}
</script>

<style lang="scss">
.yt_radio {
  font-family: var.$font-family-sf-pro-text;
  display: inline-block;
  width: 16px;
  min-width: 16px;
  height: 16px;
  min-height: 16px;
  background: #FFF;
  border: 1px solid #D1D7E8;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 200ms ease, border-width 200ms ease;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
  z-index: 0;
  &:not(.yt_radio--disabled) {
    &:hover {
      background-color: var.$gray-light;
    }
  }

  &.yt_radio--checkbox {
    border-radius: 4px;
  }

  .yt_radio--disabled {
    cursor: not-allowed;
    background-color: var.$gray-light;
    border-color: var.$gray-light;
  }
}

.yt_radio-label:hover {
  & .yt_radio:not(.yt_radio--disabled, .yt_radio--active) {
    background-color: var.$gray-light;
  }
  & .yt_radio--active:not(.yt_radio--disabled) {
    background-color: var.$green-hover;
  }
}

.yt_radio--active {
  background-size: 70%;
  border-width: 0;
  background-color: var.$green-main;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  &:not(.yt_radio--checkbox)::before {
    width: 6px;
    height: 6px;
    background: #fff;
    border-radius: inherit;
    content: '';
    display: inline-block;
    position: absolute;
  }

  &.yt_radio--checkbox {
    background: url('/static/i/check.svg') no-repeat center;
    background-color: var.$green-main;
  }
}

.yt_radio--disabled {
  border-color: var.$gray-dark;
  background-color: var.$gray-light;

  cursor: initial;
  &.yt_radio--active {
    background-color: var.$gray-dark;
  }
}

.yt_radio-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  line-height: 18px;
  color: #121212;
  &.yt_radio-label--disabled {
    cursor: initial;
  }
  user-select: none;
}

</style>
